import { ReactElement } from 'react';

import { BoundServiceCreateCommand } from '@dreryk/egabinet-patient-portal-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent, ModalConfirmButton } from '@dreryk/react-components';

import { boundServiceTranslationKeys } from '../../../translations';

import {
   HealthcareProviderPatientPortalBoundServiceCreateFormBean,
   HealthcareProviderPatientPortalBoundServiceCreateFormController,
} from './healthcareProviderPatientPortalBoundServiceCreate.types';

type HealthcareProviderPatientPortalBoundServiceButtonProps = {
   readonly handleSubmit: HealthcareProviderPatientPortalBoundServiceCreateFormController['handleSubmit'];
   readonly onSuccess: VoidFunction;
};

const useHealthcareProviderPatientPortalBoundServiceCreateCommand = (
   onSuccess: VoidFunction
): UseCqrsCommandResult<void, HealthcareProviderPatientPortalBoundServiceCreateFormBean> => {
   return useCqrsCommand(
      (parameters) => {
         const command = new BoundServiceCreateCommand();
         command.patientPortalServiceId = parameters.patientPortalService!.id;
         command.receptionServiceId = parameters.receptionService!.id;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(boundServiceTranslationKeys.boundServiceCreated);
            onSuccess();
         },
      }
   );
};

export const HealthcareProviderPatientPortalBoundServiceCreateButton = (
   props: HealthcareProviderPatientPortalBoundServiceButtonProps
): ReactElement => {
   const {
      executeAsync: createHealthcareProviderPatientPortalBoundService,
   } = useHealthcareProviderPatientPortalBoundServiceCreateCommand(props.onSuccess);

   return (
      <ModalConfirmButton
         label={boundServiceTranslationKeys.bound}
         onClick={props.handleSubmit(createHealthcareProviderPatientPortalBoundService)}
      />
   );
};
